import { render } from "./addSeller.vue?vue&type=template&id=d937122c&scoped=true"
import script from "./addSeller.vue?vue&type=script&lang=js"
export * from "./addSeller.vue?vue&type=script&lang=js"

import "./addSeller.vue?vue&type=style&index=0&id=d937122c&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/jk-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d937122c"]])

export default __exports__